import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const HeartAnimation = ({ trigger, onComplete }) => {
  const [hearts, setHearts] = useState([]);

  useEffect(() => {
    if (trigger) {
      const newHearts = Array.from({ length: 12 }, (_, i) => ({
        id: Date.now() + i,
        x: Math.random() * 200 - 100,
        delay: Math.random() * 0.3,
        scale: 0.5 + Math.random() * 0.5,
      }));
      setHearts(newHearts);

      setTimeout(() => {
        setHearts([]);
        onComplete?.();
      }, 2000);
    }
  }, [trigger, onComplete]);

  return (
    <div className="heart-animation-container">
      <AnimatePresence>
        {hearts.map((heart) => (
          <motion.div
            key={heart.id}
            className="floating-heart"
            initial={{ 
              opacity: 1, 
              y: 0, 
              x: 0, 
              scale: 0 
            }}
            animate={{ 
              opacity: 0, 
              y: -150, 
              x: heart.x, 
              scale: heart.scale,
              rotate: Math.random() * 30 - 15
            }}
            exit={{ opacity: 0 }}
            transition={{ 
              duration: 1.5, 
              delay: heart.delay,
              ease: "easeOut"
            }}
          >
            ❤️
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};

export const HeartButton = ({ onClick, active }) => {
  const [isAnimating, setIsAnimating] = useState(false);

  const handleClick = () => {
    setIsAnimating(true);
    onClick?.();
  };

  return (
    <div className="heart-button-wrapper">
      <HeartAnimation 
        trigger={isAnimating} 
        onComplete={() => setIsAnimating(false)} 
      />
      <motion.button
        className={`heart-button ${active ? 'active' : ''}`}
        onClick={handleClick}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
      >
        <motion.span
          animate={isAnimating ? {
            scale: [1, 1.3, 1],
            rotate: [0, -10, 10, 0]
          } : {}}
          transition={{ duration: 0.4 }}
        >
          {active ? '💕' : '🤍'}
        </motion.span>
      </motion.button>
    </div>
  );
};

export const FloatingHeartsBackground = () => {
  const [hearts, setHearts] = useState([]);

  useEffect(() => {
    const interval = setInterval(() => {
      const newHeart = {
        id: Date.now(),
        x: Math.random() * 100,
        size: 10 + Math.random() * 20,
        duration: 8 + Math.random() * 4,
      };
      setHearts(prev => [...prev.slice(-8), newHeart]);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="floating-hearts-background">
      <AnimatePresence>
        {hearts.map((heart) => (
          <motion.div
            key={heart.id}
            className="bg-heart"
            style={{
              left: `${heart.x}%`,
              fontSize: heart.size,
            }}
            initial={{ opacity: 0, y: '100vh' }}
            animate={{ 
              opacity: [0, 0.3, 0.3, 0],
              y: '-10vh',
              x: [0, Math.random() * 50 - 25, 0]
            }}
            transition={{ 
              duration: heart.duration,
              ease: "linear"
            }}
          >
            💕
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};

export default HeartAnimation;
